export default "__VITE_ASSET__Cfu1Puut__"